<mat-toolbar color="primary" class="custom-header">
  <button mat-icon-button (click)="guiService.goTo('main/diary')">
    <mat-icon svgIcon="mat:chevron_left"></mat-icon>
  </button>
</mat-toolbar>

<!-- Se ci sono preferiti -->
<div class="container" *ngIf="!workoutNameLoader && favorites.length > 0">
  <h2>{{"DIARY.FAVORITES" | translate}}</h2>

  <!-- Search input sostituito -->
  <mat-form-field  class="search-favorite">
    <input
      matInput
      type="text"
      placeholder="{{'GENERIC.SEARCH' | translate}}"
      [(ngModel)]="searchCtrl"
      (ngModelChange)="filterFavorites()"
      required
    />
  </mat-form-field>

  <!-- Lista dei preferiti -->
  <div class="favorites-container" *ngFor="let favorite of filteredFavorites; let i = index">
    <div class="favorite" [class]="guiService.evaluateBgColor(i)" (click)="goToWorkout(favorite.workoutId)">
      <span class="max-w">
        <p>{{getProgramName(favorite.programId)[translate.currentLang.toUpperCase()]}}</p>
        <p class="workout-name">{{workoutNameMap[favorite.workoutId].i18nName[translate.currentLang.toUpperCase()]}}</p>
        <p>{{"DIARY.WEEK" | translate}} {{favorite.week}} · {{"DIARY.DAY" | translate}} {{favorite.day}}</p>
      </span>
      <img class="workout-img" [src]="environment.workouts + '/' + favorite.workoutId + '/images/main'">
    </div>

    <!-- Pulsante rimozione preferito -->
    <div class="favorite-status">
      <div class="fav-btn"
           (click)="openModalFavoriteStatus(favorite, workoutNameMap[favorite.workoutId].i18nName[translate.currentLang.toUpperCase()])"
           *ngIf="!isMatch(favoriteLoading, favorite)">
        <mat-icon svgIcon="mat:favorite"></mat-icon>
      </div>
      <mat-spinner *ngIf="isMatch(favoriteLoading, favorite)" diameter="14"></mat-spinner>
    </div>
  </div>
</div>

<!-- Placeholder loading -->
<div class="container" *ngIf="workoutNameLoader && favorites.length > 0">
  <h2>{{"DIARY.FAVORITES" | translate}}</h2>

  <mat-form-field  class="custom-input">
    <input
      matInput
      type="text"
      placeholder="{{'GENERIC.SEARCH' | translate}}"
      required
    />
  </mat-form-field>

  <div class="favorites-container-placeholder" *ngFor="let workout of workoutsPlaceholder; let i = index">
    <div class="skeleton" style="height: 100px; width: 90%;"></div>
    <div class="skeleton" style="height: 30px; width: 10%; margin-left: 5px;"></div>
  </div>
</div>

<!-- Nessun preferito -->
<div class="container" *ngIf="!guiService.userLogged?.workoutInfo?.favorites || guiService.userLogged?.workoutInfo?.favorites.length === 0">
  <h2>{{"DIARY.FAVORITES" | translate}}</h2>
  <p class="no-content">{{"DIARY.NO-CONTENT" | translate}}</p>
</div>
